// Desktop user menu: organization switch, role-gated admin pages, logout.

import {
  Avatar,
  Box,
  HStack,
  Icon,
  Menu,
  MenuButton,
  MenuDivider,
  MenuGroup,
  MenuItem,
  MenuList,
  Text,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { FiChevronDown } from 'react-icons/fi';
import { MdLogout, MdSwapHoriz } from 'react-icons/md';
import type { DashboardNav } from './useDashboardNav';

export function DashboardUserMenu({ nav }: { nav: DashboardNav }) {
  return (
    <Menu placement="bottom-end">
      <MenuButton
        data-testid="user-menu-button"
        px={2}
        py={1}
        borderRadius="full"
        _hover={{ bg: 'interactive-hover' }}
      >
        <HStack spacing={2}>
          <Avatar size="sm" name={nav.userName} bg="brand.500" color="white" />
          <Box textAlign="left" lineHeight="short">
            <Text fontSize="sm" fontWeight="500" color="text-primary">
              {nav.userName}
            </Text>
            <Text fontSize="xs" color="text-muted">
              {nav.orgName}
            </Text>
          </Box>
          <Icon as={FiChevronDown} color="text-muted" />
        </HStack>
      </MenuButton>
      <MenuList zIndex="dropdown">
        <MenuItem icon={<MdSwapHoriz size={18} />} onClick={nav.switchOrg}>
          Switch organization
        </MenuItem>
        {nav.adminLinks.length > 0 && (
          <>
            <MenuDivider />
            <MenuGroup title="Admin">
              {nav.adminLinks.map((link) => (
                <MenuItem
                  key={link.key}
                  as={RouterLink}
                  to={link.path}
                  icon={<Icon as={link.icon} boxSize={4} />}
                  data-testid={`user-menu-item-${link.key}`}
                  aria-current={nav.activeLinkKey === link.key ? 'page' : undefined}
                >
                  {link.label}
                </MenuItem>
              ))}
            </MenuGroup>
          </>
        )}
        <MenuDivider />
        <MenuItem icon={<MdLogout size={18} />} color="red.600" onClick={nav.logout}>
          Log out
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
